import { closeIcon } from "../../assets/svgs/icons/icons.svg";
import styles from "./InscriptionAnnuleeNotification.module.scss";
import { useTranslation } from "react-i18next";

type Props = {
  isNotifVisible: boolean;
  setIsNotVisible: (newState: boolean) => void;
};
export default function InscriptionAnnuleeNotification(props: Props) {
  const { isNotifVisible, setIsNotVisible } = props;
  const { t } = useTranslation();

  function hideNotification() {
    setIsNotVisible(false);
  }
  return (
    <>
      {isNotifVisible && (
        <article className={styles.inscriptionAnnuleeNotification}>
          <header className={styles.inscriptionAnnuleeNotification__header}>
            <h1>{t("inscriptionAnnuleeNotification.title")}</h1>
            <button type="button" onClick={hideNotification}>
              {closeIcon}
            </button>
          </header>
          <main className={styles.inscriptionAnnuleeNotification__main}>
            <p>{t("inscriptionAnnuleeNotification.dataDeleted")}</p>
            <p>
              {t("inscriptionAnnuleeNotification.reregisterUntil")}
            </p>
          </main>
        </article>
      )}
    </>
  );
}
